import React, { useContext } from "react";
import styled from "styled-components";
import { Box } from "reflexbox";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const FAQItem = styled(Box)`
  border-bottom: 1px solid rgba(96, 113, 123, 0.12);
  padding: 24px 0;

  &:first-child {
    border-top: 1px solid rgba(96, 113, 123, 0.12);
  }
`;

export function GuideFAQs({ faqs }) {
  const crownPrice = useContext(CrownPriceContext);
  const opts = { crownPrice };
  if (!faqs?.length) return null;

  return (
    <Box mt={[40, 50]}>
      <Box
        fontSize={[22, 26]}
        fontWeight={500}
        color={colors.primaryBright}
        mb={[3]}
      >
        Frequently Asked Questions
      </Box>
      {faqs.map((faq, i) => (
        <FAQItem key={i}>
          <Box
            fontSize={[16, 17]}
            fontWeight={500}
            color={colors.light}
            mb={[2]}
            style={{ lineHeight: "155%" }}
          >
            {parseMarkdownLinks(faq.question, opts)}
          </Box>
          <Box
            fontSize={[14, 15]}
            color={colors.text}
            style={{ lineHeight: "175%" }}
          >
            {parseMarkdownLinks(faq.answer, opts)}
          </Box>
        </FAQItem>
      ))}
    </Box>
  );
}
